<template>
  <modal
    :show.sync="showChangePartnerModal"
    modalContentClasses=""
    modalClasses="modal-alert"
    type="mini"
    @close="closeChangePartnerModal(false)"
    no-close-on-backdrop
  >
    <div
      class="col-12 pt-4 pb-2"
      :class="{ 'is-invalid': $v.partnerType.$error }"
    >
      <div class="text-center">
        <img
          src="~rhomtrip_assets/src/img/icons/alerts/question.png"
          alt="question"
          class="icon-modal"
        />
        <h2 class="modal-title mb-1">
          Change to Partner
        </h2>
      </div>
      <p>What type of Partner do you want to change this customer to?</p>

      <b-form-radio-group
        id="radio-approval"
        v-model="$v.partnerType.$model"
        aria-describedby="ariaDescribedby"
        name="radio-optionapproval"
        stacked
        size="md"
      >
        <b-form-radio value="travel_agency" tabindex="15"
          >Change to Travel Agency</b-form-radio
        >
        <b-form-radio value="travel_access">Change to Agent</b-form-radio>
      </b-form-radio-group>

      <small class="invalid-feedback text-center" v-if="$v.partnerType.$error"
        >Select an option</small
      >

      <div class="col-12 mt-3" v-if="partnerType === 'travel_access'">
        <WSelect
          v-bind:class="{
            'invalid-feedback': $v.selectAgency.$error
          }"
          v-model="$v.selectAgency.$model"
          label="Agency to associate"
          placeholder="Enter an Agency Name"
          id="agency_name"
          name="agency_name"
          tabindex="3"
          remote
          filterable
          reserve-keyword
          clearable
          :error="
            !$v.selectAgency.minLength || $v.selectAgency.$error
              ? `Select an Agency to associate `
              : ''
          "
        >
          <el-option
            v-for="(agency, index) in agencies"
            :value="agency._id"
            :label="getCompanyName(agency)"
            :key="index"
          ></el-option>
        </WSelect>
      </div>
    </div>
    <div
      class="border-top pt-3 text-center col-12 d-flex justify-content-around"
    >
      <base-button
        type="outline-neutral"
        class="min-button"
        @click="closeChangePartnerModal(false)"
        >Close</base-button
      >

      <base-button
        type="primary"
        class="min-button ml-auto"
        :disabled="requestInProgress"
        @click.stop="changeToPartner(customerId)"
        >Accept</base-button
      >
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { CustomersAPI } from "../../../core/api";
import { required, minLength, requiredIf } from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "ChangeToPartner",
  props: {
    show: {
      type: Boolean,
      default: false,
      description: "(closeable)"
    },
    customerId: {
      type: String,
      default: () => null,
      description: "(Reservation Id)"
    },
    agencies: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      partnerType: "",
      selectAgency: "",
      showChangePartnerModal: true,
      requestInProgress: false
    };
  },
  async created() {
    this.showChangePartnerModal = this.show;
    this.resetData();
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showChangePartnerModal = current;
        this.$v.$reset();
      },
      deep: true
    }
  },
  methods: {
    closeChangePartnerModal(status) {
      this.showChangePartnerModal = status;
      this.resetData();
      this.$emit("close", status);
    },
    resetData() {
      this.partnerType = "";
      this.selectAgency = "";
      this.$v.$reset();
    },
    customerChangeToPartner(status) {
      this.$emit("customerChanged", status);
      this.closeChangePartnerModal(false);
    },
    async changeToPartner(customerId) {
      if (!this.$v.partnerType.$invalid && !this.$v.selectAgency.$invalid) {
        if (this.partnerType === "travel_agency") {
          this.changeToPartnerById(customerId, this.partnerType);
        } else {
          this.changeToPartnerById(
            customerId,
            this.partnerType,
            this.selectAgency
          );
        }
      } else {
        this.$v.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async changeToPartnerById(customerId, partnerType, agencyId = null) {
      try {
        this.requestInProgress = true;
        let { data } = await CustomersAPI.changeToPartner(
          customerId,
          partnerType,
          agencyId,
          this.sesion.token
        );
        this.requestInProgress = false;
        if (data.status) {
          let result = data.data;
          if (result.status) {
            this.$notify({
              type: "success",
              title: "Success!",
              message: `The Customer has been changed to a ${
                partnerType === "travel_agency" ? "Travel Agency " : "Agent"
              }`,
              icon: "flaticon-check-3"
            });
            this.customerChangeToPartner(true);
          } else {
            this.$notify({
              type: "danger",
              title: "Error!",
              message:
                "The changes couldn't be save, check the Customer data and try again",
              icon: "flaticon-remove"
            });
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The changes couldn't be save, check the Customer data and try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.requestInProgress = false;
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The changes couldn't be save, check the Customer data and try again",
          icon: "flaticon-remove"
        });
      }
    },
    getCompanyName(agency) {
      if (agency.company_name) {
        return agency.company_name;
      } else {
        return ``;
      }
    },
    ...mapMutations(["setLoad"])
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  components: {
    WSelect
  },
  validations: {
    partnerType: {
      required
    },
    selectAgency: {
      minLength: minLength(2),
      required: requiredIf(function(value) {
        return this.partnerType === "travel_access";
      })
    }
  }
};
</script>
